module.exports = __webpack_public_path__ + "static/media/img-bg-jackpot-header@3x.9b138553.png";